import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IDataCollectSearchForm } from 'types/dataCollect';
import DataCollectConstants from 'pages/admin/campaign-data-collect/constants';

interface IDataCollectState {
    dataCollectSearchForm: IDataCollectSearchForm;
}

const initialState: IDataCollectState = {
    dataCollectSearchForm: {
        status: [DataCollectConstants.status.ALL],
        device: [DataCollectConstants.device.ALL],
        startDate: '',
        endDate: '',
    },
};

const dataCollectSlice = createSlice({
    name: 'dataAnalyticsFilter',
    initialState,
    reducers: {
        setDataCollectSearchForm: (
            state,
            action: PayloadAction<IDataCollectSearchForm>
        ) => {
            state.dataCollectSearchForm = {
                ...state.dataCollectSearchForm,
                ...action.payload,
            };
        },
        clearDataCollectSearchForm: (state) => {
            state.dataCollectSearchForm = initialState.dataCollectSearchForm;
        },
    },
});

export const { setDataCollectSearchForm, clearDataCollectSearchForm } =
    dataCollectSlice.actions;

export default dataCollectSlice.reducer;
